import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import VideoShowcase from './VideoShowcase'

// Route wrapper for /dpp/training/videos/:categoryId — renders the reusable VideoShowcase.
function TrainingVideos() {
  const navigate = useNavigate()
  const { categoryId } = useParams<{ categoryId: string }>()

  return <VideoShowcase categoryId={Number(categoryId)} onBack={() => navigate('/dpp/training')} />
}
export default TrainingVideos
